import { createAction } from "@reduxjs/toolkit";

import type {
  ScreenDataUpdateRequest,
  UsernameRequest,
  TeacherUsernameRequest,
  BackgroundListGetRequest,
  BoardInfoGetRequest,
  BoardListGetRequest,
  BoardPageFormData,
  BoardPageDeleteFormData,
  BoardElementListGetRequest,
  BoardDrawDataGetRequest,
  BoardDrawDataCreateFormData,
  BoardDrawDataUpdateFormData,
  ElementCreateFormData,
  ElementDeleteFormData,
  ElementGroupDeleteFormData,
  ImageListGetRequest,
  CreateMemberFormData,
  CreateCardFormData,
  BoardLastPageRequest,
  BoardElementListCopyRequest,
} from "./types";

export const ScreenDataUpdateAction = createAction<ScreenDataUpdateRequest>("SCREEN_DATA_UPDATE");
export const UsernameAction = createAction("USERNAME_GET");
export const TeacherUsernameAction = createAction<TeacherUsernameRequest>("TEACHER_USERNAME_GET");

export const BackgroundListGetAction = createAction<BackgroundListGetRequest>("BACKGROUND_LIST_GET");
export const BackgroundCategoryGetAction = createAction("BACKGROUND_CATEGORY_GET");
export const UserBackgroundListGetAction = createAction("USER_BACKGROUND_LIST_GET");

export const BoardInfoGetAction = createAction<BoardInfoGetRequest>("BOARD_INFO_GET");
export const BoardLastPageAction = createAction<BoardLastPageRequest>("BOARD_LAST_PAGE_SET");
export const BoardListGetAction = createAction<BoardListGetRequest>("BOARD_LIST_GET");
export const BoardPageCreateAction = createAction<BoardPageFormData>("BOARD_PAGE_CREATE");
export const BoardPageUpdateAction = createAction<BoardPageFormData>("BOARD_PAGE_UPDATE");
export const BoardPageDeleteAction = createAction<BoardPageDeleteFormData>("BOARD_PAGE_DELETE");
export const BoardPageCopyAction = createAction<BoardPageFormData>("BOARD_PAGE_COPY");

export const ImageListGetAction = createAction<ImageListGetRequest>("IMAGE_LIST_GET");

export const BoardElementListGetAction = createAction<BoardElementListGetRequest>("BOARD_ELEMENT_LIST_GET");
export const BoardElementDeleteAction = createAction<ElementDeleteFormData>("BOARD_ELEMENT_DELETE");
export const BoardElementGroupDeleteAction = createAction<ElementGroupDeleteFormData>("BOARD_ELEMENT_GROUP_DELETE");
export const MemberCreateAction = createAction<CreateMemberFormData>("MEMBER_CREATE");
export const MemberListGetAction = createAction("MEMBER_LIST_GET");

export const CardCreateAction = createAction<CreateCardFormData>("Card_CREATE");
export const CardListGetAction = createAction("Card_LIST_GET");

export const WorkListGetAction = createAction("WORK_LIST_GET");

export const BoardDrawDataGetAction = createAction<BoardDrawDataGetRequest>("BOARD_DRAW_DATA_GET");
export const BoardDrawDataCreateAction = createAction<BoardDrawDataCreateFormData>("BOARD_DRAW_DATA_CREATE");
export const BoardDrawDataUpdateAction = createAction<BoardDrawDataUpdateFormData>("BOARD_DRAW_DATA_UPDATE");

export const BoardElementListCopyAction = createAction<BoardElementListCopyRequest>("BOARD_ELEMENT_COPY");
export const BoardElementListCopyForNowPageAction = createAction<BoardElementListCopyRequest>("BOARD_ELEMENT_COPY_FOR)NOW_PAGE");

